import React, { useEffect, useState } from "react";
import axios from "axios";
import { Modal, Button, Form, Col, Row } from "react-bootstrap";
import "./index.scss"; // Assurez-vous d'importer le fichier CSS pour le style
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";

import "react-toastify/dist/ReactToastify.css";
import { ToastContainer,toast } from "react-toastify";
import { checkEmailExistence } from "../../services/params";

const CreateClient = ({ show, handleClose, onUserAdded }) => {
  
  const [data, setData] = useState({
    firstname: "",
    lastname: "",
    email: "",
    phone: "",
    company: "",
    birthDate: "",
    country: "",
    city: "",
    image: null,
    password: "",
    confirmPassword: "",
    // status: "Nouveau", // valeur par défaut
    Role: "client", // valeur par défaut
  });
  const roles = [
    { value: "admin", label: "Admin" },
    { value: "client", label: "Client" },
    { value: "gestionnaire", label: "Gestionnaire" },
  ];
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [confirmPasswordVisible, setConfirmPasswordVisible] = useState(false);
  const togglePasswordVisibility = () => setPasswordVisible(!passwordVisible);
  const passwordMismatch =
    data.password &&
    data.confirmPassword &&
    data.password !== data.confirmPassword;
  const toggleConfirmPasswordVisibility = () =>
    setConfirmPasswordVisible(!confirmPasswordVisible);
  const handleChange = (e) => {
    const { name, value, files } = e.target;
    if (name === "image") {
      setData({ ...data, image: files[0] });
    } else {
      setData({ ...data, [name]: value });
    }
  };

 const handleSubmit = async (e) => {
   e.preventDefault();

   const emailExists = await checkEmailExistence(data.email);
   if (emailExists) {
     toast.error("Cet email est déjà utilisé. Veuillez en choisir un autre.");
     return;
   }

   const formData = new FormData();
   for (const key in data) {
     if (key !== "image") {
       // Ignore image for now as it’s handled separately
       formData.append(key, data[key] || "");
     }
   }
   if (data.image) formData.append("image", data.image);

   try {
     await axios.post("/users/register", formData, {
       headers: {
         "Content-Type": "multipart/form-data",
       },
     });

     toast.success("Utilisateur ajouté avec succès !", {
       autoClose: 3000,
       hideProgressBar: false,
       closeOnClick: true,
       pauseOnHover: false,
       draggable: true,
     });

     onUserAdded?.();
     handleClose();

     // Reset form state
     setData({
       firstname: "",
       lastname: "",
       email: "",
       phone: "",
       company: "",
       birthDate: "",
       country: "",
       city: "",
       image: null,
       password: "",
       confirmPassword: "",
       Role: "client",
     });
   } catch (error) {
     console.error("Erreur lors de l'ajout :", error.response?.data || error);
     toast.error("Échec de l'ajout de l'utilisateur !");
   }
 };
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setData((prevData) => ({
        ...prevData,
        KBIS: file,
      }));
    }
  };
useEffect(() => {
  if (show) {
    setData({
      firstname: "",
      lastname: "",
      email: "",
      phone: "",
      company: "",
      birthDate: "",
      country: "",
      city: "",
      KBIS: "",
      image: null,
      password: "",
      confirmPassword: "",
      status: "Nouveau",
      Role: "client",
      SIREN: "",
      SIRET: "",
    });
  }
}, [show]);
  return (
    <>
      <Modal
        show={show}
        onHide={handleClose}
        centered
        dialogClassName="custom-modal-width custom-modal-user"
      >
        <Form onSubmit={handleSubmit} encType="multipart/form-data">
          <Modal.Header closeButton>
            <Modal.Title>Ajouter un Utilisateur</Modal.Title>
          </Modal.Header>
          <Modal.Body className="row mailing-section p-3">
            <Form.Group className="row  ">
              <div className="col-md-6">
                <Form.Label class="mb-3 mt-4 secteur-title">Prénom</Form.Label>
                <Form.Control
                  name="firstname"
                  value={data.firstname}
                  onChange={handleChange}
                  required
                  placeholder="Entrez le prénom"
                />
              </div>

              <div className="col-md-6">
                <Form.Label class="mb-3 mt-4 secteur-title">Nom</Form.Label>
                <Form.Control
                  name="lastname"
                  value={data.lastname}
                  onChange={handleChange}
                  required
                  placeholder="Entrez le nom"
                />
              </div>
            </Form.Group>

            <Form.Group className="row ">
              <Form.Label class="mb-3 mt-4 secteur-title">Rôle</Form.Label>
              <Form.Control
                as="select"
                name="Role"
                value={data.Role}
                onChange={handleChange}
                required
              >
                <option value="">-- Choisir un rôle --</option>
                {roles.map((role) => (
                  <option key={role.value} value={role.value}>
                    {role.label}
                  </option>
                ))}
              </Form.Control>
            </Form.Group>

            <Form.Group className="row ">
              <Form.Label class="mb-3 mt-4 secteur-title">Email</Form.Label>
              <Form.Control
                name="email"
                type="email"
                value={data.email}
                onChange={handleChange}
                required
                placeholder="Entrez l'adresse email"
              />
            </Form.Group>

            <Form.Group className="row  ">
              <Form.Label class="mb-3 mt-4 secteur-title">Téléphone</Form.Label>
              <Form.Control
                name="phone"
                value={data.phone}
                onChange={handleChange}
                placeholder="Entrez le numéro de téléphone"
                required
              />
            </Form.Group>
            {data.Role === "client" && (
              <>
                <Row className="mb-3 mt-4">
                  <Col md={6}>
                    <Form.Group>
                      <Form.Label className="secteur-title">
                        Secteur d'activité
                      </Form.Label>
                      <Form.Control
                        name="activitySector"
                        value={data.activitySector}
                        onChange={handleChange}
                        placeholder="Entrez le secteur d'activité"
                        required
                      />
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <Form.Group>
                      <Form.Label className="secteur-title">
                        Entreprise
                      </Form.Label>
                      <Form.Control
                        name="company"
                        value={data.company}
                        onChange={handleChange}
                        placeholder="Entrez le nom de l'entreprise"
                        required
                      />
                    </Form.Group>
                  </Col>
                </Row>
                <Form.Group>
                  <Form.Label className="mb-3 mt-4 secteur-title">
                    KBIS
                  </Form.Label>
                  <div className="custom-file-wrapper">
                    <input
                      type="file"
                      name="KBIS"
                      className="custom-file-input"
                      onChange={handleFileChange}
                      accept=".pdf,.jpg,.jpeg,.png,.docx"
                      required
                      id="kbisUpload"
                    />
                    <div className="custom-file-placeholder">
                      {data.KBIS?.name ||
                        "(upload de fichiers, formats acceptés : PDF, JPG, PNG, DOCX, etc.)"}

                      <button
                        type="button"
                        className="custom-upload-btn"
                        onClick={() =>
                          document.getElementById("kbisUpload").click()
                        }
                      >
                        Joindre
                      </button>
                    </div>
                  </div>
                </Form.Group>

                <Row className="mb-3 mt-4">
                  <Col md={6}>
                    <Form.Group>
                      <Form.Label className="secteur-title">SIRET</Form.Label>
                      <Form.Control
                        name="SIRET"
                        value={data.SIRET}
                        onChange={handleChange}
                        placeholder="Entrez le numéro SIRET"
                      />
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <Form.Group>
                      <Form.Label className="secteur-title">SIREN</Form.Label>
                      <Form.Control
                        name="SIREN"
                        value={data.SIREN}
                        onChange={handleChange}
                        placeholder="Entrez le numéro SIREN"
                      />
                    </Form.Group>
                  </Col>
                </Row>
              </>
            )}

            <div className="row">
              <div className="col-6">
                <Form.Group>
                  <Form.Label className="mb-3 mt-4 secteur-title">
                    Ville
                  </Form.Label>
                  <Form.Control
                    name="city"
                    value={data.city}
                    onChange={handleChange}
                    required
                    placeholder="Entrez ville"
                  />
                </Form.Group>
              </div>

              <div className="col-6">
                <Form.Group>
                  <Form.Label className="mb-3 mt-4 secteur-title">
                    Pays{" "}
                  </Form.Label>
                  <Form.Control
                    name="country"
                    value={data.country}
                    onChange={handleChange}
                    required
                    placeholder="Entrez pays"
                  />
                </Form.Group>
              </div>
            </div>

            <div className="row">
              <div className="col-6">
                <Form.Group>
                  <Form.Label className="mb-3 mt-4 secteur-title">
                    Mot de passe
                  </Form.Label>

                  <div className="position-relative">
                    <Form.Control
                      name="password"
                      type={passwordVisible ? "text" : "password"}
                      value={data.password}
                      onChange={handleChange}
                      required
                      placeholder="Créez un mot de passe"
                    />
                    <FontAwesomeIcon
                      icon={passwordVisible ? faEyeSlash : faEye}
                      onClick={togglePasswordVisibility}
                      className="eye-icon"
                    />
                  </div>
                </Form.Group>
              </div>

              <div className="col-6">
                <Form.Group>
                  <Form.Label className="mb-3 mt-4 secteur-title">
                    Confirmer le mot de passe
                  </Form.Label>

                  <div className="position-relative">
                    <Form.Control
                      name="confirmPassword"
                      type={confirmPasswordVisible ? "text" : "password"}
                      value={data.confirmPassword}
                      onChange={handleChange}
                      required
                      placeholder="Confirmez le mot de passe"
                    />
                    <FontAwesomeIcon
                      icon={confirmPasswordVisible ? faEyeSlash : faEye}
                      onClick={toggleConfirmPasswordVisibility}
                      className="eye-icon"
                    />
                  </div>

                  {passwordMismatch && (
                    <Form.Text className="text-danger">
                      Les mots de passe ne correspondent pas.
                    </Form.Text>
                  )}
                </Form.Group>
              </div>
            </div>

            <Form.Group className="row  ">
              <Form.Label class="mb-3 mt-4 secteur-title">Image</Form.Label>
              <Form.Control name="image" type="file" onChange={handleChange} />
            </Form.Group>

            {/* Les champs comme status et Role sont envoyés en background */}
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="none"
              className="AppButton secondary"
              onClick={handleClose}
            >
              ANNULER
            </Button>
            <Button variant="none" className="AppButton primary" type="submit">
              AJOUTER
            </Button>
          </Modal.Footer>
        </Form>
        <ToastContainer autoClose={3000} />
      </Modal>
    </>
  );
};

export default CreateClient;
